module.exports = __webpack_public_path__ + "media/images/icon_setting-e088a252bf2ef0d6ab10fa4bd24424fb.svg";